import { render, staticRenderFns } from "./IncomeTab.vue?vue&type=template&id=0214e3b5"
import script from "./IncomeTab.vue?vue&type=script&lang=js"
export * from "./IncomeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports